import classNames from "classnames";
import { useState } from "react";
import { ModalComponent } from "../../..";
import { formatToCurrency } from "../../../../../helperFunctions";
import { SingleCooperative } from "../../../../../redux/features/cooperative/cooperative.type";
import { CooperativeWithdrawalPayload } from "../../../../../redux/features/finances/finances.type";
import { SuccessModal } from "../../successModal";
import { StepOne } from "./stepOne";
import { StepThree } from "./stepThree";
import { StepTwo } from "./stepTwo";

const stepMap = {
  1: "Withdrawal",
  2: "How much do you want to withdraw?",
  3: "Code",
};

export const CooperativeWithdrawalModal = ({
  modal,
  modalOpen,
  onModalClose,
  cooperativeDetails,
  onSuccess,
}: {
  modal: string;
  modalOpen: boolean;
  onModalClose: () => void;
  cooperativeDetails: SingleCooperative;
  onSuccess: () => void;
}) => {
  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [payload, setPayload] =
    useState<Partial<CooperativeWithdrawalPayload>>();

  const handleModalClose = () => {
    setStep(1);
    setPayload(undefined);
    onModalClose();
  };

  return (
    <>
      <ModalComponent
        isModalOpen={modalOpen && modal === "cooperativeWithdrawalModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        title={stepMap[step]}
        childrenClassName={classNames("flex", {
          "!mt-2": step !== 2,
        })}
        modalClassName="!min-h-[448px]"
        hasButtons={false}
      >
        {step === 1 ? (
          <StepOne
            onSuccess={() => {
              setStep(2);
            }}
          />
        ) : undefined}

        {step === 2 && (
          <StepTwo
            onSuccess={(amount) => {
              setPayload({ amount: amount });
              setStep(3);
            }}
          />
        )}

        {step === 3 && payload?.amount ? (
          <StepThree
            amount={payload.amount}
            cooperativeDetails={cooperativeDetails}
            onSuccess={() => {
              onSuccess();
            }}
          />
        ) : undefined}
      </ModalComponent>

      <SuccessModal
        message={"Withdrawal initiated successfully"}
        isModalOpen={modalOpen && modal === "withdrawalInitiationSuccessModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        subText={
          <span>
            Once approved,{" "}
            <span className="font-bold text-pry-green-200">
              {formatToCurrency(payload?.amount ?? 0, {
                currency: "NGN",
                decimalPlaces: 2,
              })}
            </span>{" "}
            will be sent to{" "}
            <span className="font-bold text-pry-green-200">
              {cooperativeDetails.CoopName}'s
            </span>{" "}
            linked bank account
          </span>
        }
        callback={() => {}}
      />
    </>
  );
};
